"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT_SELECTOR_BY_KEY = exports.VARIANT_B = exports.VARIANT_A = exports.VARIANT = exports.TEAMS = exports.SEGMENT = exports.RUDDERSTACK_ANONYMOUS_ID_COOKIE_NAME = exports.RUDDERSTACK = exports.OUT_OF_EXPERIMENT = exports.GTM_ID = exports.CONTROL = exports.ATTRIBUTION_COOKIE_NAME = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var ATTRIBUTION_COOKIE_NAME = exports.ATTRIBUTION_COOKIE_NAME = 'attribution_user_id';
var RUDDERSTACK_ANONYMOUS_ID_COOKIE_NAME = exports.RUDDERSTACK_ANONYMOUS_ID_COOKIE_NAME = 'rl_anonymous_id';
var CONTROL = exports.CONTROL = 'control';
var VARIANT = exports.VARIANT = 'variant';
var VARIANT_A = exports.VARIANT_A = 'variantA';
var VARIANT_B = exports.VARIANT_B = 'variantB';
var OUT_OF_EXPERIMENT = exports.OUT_OF_EXPERIMENT = 'out_of_experiment';
var GTM_ID = exports.GTM_ID = 'GTM-TZXJTPF';
var TEAMS = exports.TEAMS = {
  DATA: 'Data',
  DATA_ENABLERS: 'data_enablers',
  DATA_PEOPLE: 'data_people',
  DATA_SCIENCE: 'data_science',
  MACHINE_LEARNING: 'machine_learning',
  DEVELOPER_TOWN: 'developer_town_developers',
  DEVELOPERS: 'developers',
  ACTIONABLE_DATA: 'actionable_data',
  PERFORMANCE_ANALYTICS: 'perfomance_nalytics',
  RESPONSE_INSIGHTS: 'response_insights',
  // legacy owner name for response_data
  RESPONSE_DATA: 'response_data',
  CONVERSATIONS: 'conversations',
  CREATE: 'create',
  PERSONALIZE: 'personalize',
  RESPOND: 'respond',
  REACH: 'reach',
  CORPORATE: 'corporate',
  CORPORATE_INFRASTRUCTURE: 'corporate_infrastructure',
  ENTERPRISE_TOOLS: 'enterprise_tools',
  CUSTOMER_ENGAGEMENT: 'customer_engagement',
  PRODUCT_EXPERIENCE: 'product_experience',
  WORKFLOWS: 'workflows',
  DATA_PLATFORM: 'data_platform',
  DATA_ENGINEERING: 'data_engineering',
  DATA_TRACKING: 'data_tracking',
  DEVELOPER_RELATIONS: 'developer_relations',
  ECOSYSTEMS: 'ecosystems',
  BLOCKS: 'blocks',
  CHANNEL_EXPERIENCE: 'channel_experience',
  PARTNERSHIPS: 'partnerships',
  SURFACES: 'surfaces',
  GROWTH: 'growth',
  REVENUE: 'revenue',
  SUBSCRIPTIONS: 'subscriptions',
  WEB: 'web',
  WEB_OPS: 'web_ops',
  SELF_SERVE: 'self_serve',
  HORIZON_3: 'horizon_3',
  PLATFORM: 'platform',
  BACKEND_ARCHITECTURE: 'backend_architecture',
  DEVTOOLS: 'devtools',
  FRONTEND_ARCHITECTURE: 'frontend_architecture',
  SHARED_SERVICES: 'shared_services',
  PRODUCT_INFRAESTRUCTRE: 'product_infrastructure',
  QUALITY: 'quality',
  ENGINEERING_INTELLIGENCE: 'engineering_intelligence',
  QUALITY_ASSISTANCE: 'quality_assistance',
  R_AND_D: 'r&d',
  TEAMS_AND_ENTERPRISE: 'teams_and_enterprise',
  USERS_AND_COLLABORATION: 'users_and_collaboration',
  VIDEOASK: 'videoask',
  VIDEOASK_CORE: 'videoask_core',
  VIDEOASK_FRONTEND: 'videoask_frontend',
  VIDEOASK_GROWTH: 'videoask_growth',
  FINANCE: 'finance',
  GLOBANT_DEVELOPERS: 'globant_developers',
  SECURITY: 'security',
  STICKYEYES: 'stickyeyes_developers',
  THOUGHTWORKS_DEVELOPERS: 'thoughtworks_developers',
  MULTIFORMAT: 'multiformat',
  SITE_TEAM: 'site_teams',
  DEFAULT: 'no_owner',
  INSIGHTS: 'insights',
  INTEGRATIONS: 'integrations'
};
var SEGMENT = exports.SEGMENT = 'segment';
var RUDDERSTACK = exports.RUDDERSTACK = 'rudderstack';
var VARIANT_SELECTOR_BY_KEY = exports.VARIANT_SELECTOR_BY_KEY = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, CONTROL, 'isControl'), VARIANT, 'isVariant'), VARIANT_A, 'isVariantA'), VARIANT_B, 'isVariantB'), OUT_OF_EXPERIMENT, 'isOOE');